import { jsxs as l, jsx as e } from "react/jsx-runtime";
import { useState as t, useEffect as c } from "react";
function n({
  isAppLoading: s = !1,
  minDurationInMs: r = 800,
  children: a
}) {
  const [
    i,
    o
  ] = t(!1);
  return c(() => {
    setTimeout(
      () => o(!0),
      r
      // https://developer.fr.world.socgen/rtd/design-system/v5/components/service-loader.html
    );
  }, [r]), s || !i ? /* @__PURE__ */ l("div", { className: "service-loader d-flex flex-column", children: [
    /* @__PURE__ */ e("div", { className: "service-loader-logo" }),
    /* @__PURE__ */ e("div", { className: "progress progress-sm progress-container", children: /* @__PURE__ */ e(
      "div",
      {
        "data-e2e": "service-loader",
        className: "progress-bar animated-progress",
        role: "progressbar"
      }
    ) })
  ] }) : a;
}
export {
  n as ServiceLoader
};
